import { buildLocalImage } from "./buildLocalImage";
import fallbackTileImageUrl from "./fallback-tile.svg";

export const fallbackTileImage = buildLocalImage(fallbackTileImageUrl, {
    alt: "",
    width: 200,
    height: 200,
    mimetype: "image/svg+xml",
});
